import styled from "styled-components";
import {PrimaryButtonInverted} from "../../../basic-components/buttons/primary-button-inverted";

export const DeleteButtonBox = styled(PrimaryButtonInverted)`
`
